import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockComplete, makeStreamEnd } from '../sseEvents';
const RESPONSE_ID = 'resp-defl-nosup';
const CONV_ID = 'conv-1';
const DEFL_BLOCK_ID = 'blk-defl-nosup';
const deflectionBlock = {
    type: 'deflection',
    block_id: DEFL_BLOCK_ID,
    block_index: 0,
    message: 'That question is outside my area of expertise. Here are some things I can help with:',
    category: 'other',
    examples: [
        'Show me overdue inspections',
        'How many fire extinguishers are in Building A?',
        'Look up NFPA 25 sprinkler requirements'
    ]
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockComplete(deflectionBlock, 200),
    makeStreamEnd(RESPONSE_ID, 1, mockOfficeAgent)
];
export const scenario = {
    name: 'Deflection — No Support Link',
    description: 'Deflection response without a support URL, showing alternative example prompts.',
    conversations: mockConversations,
    userMessage: 'What is the meaning of life?',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
